import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { changeProductImageHoverStatus, placeItemInCart, changeRelatedProductsPopupVisibility } from '../../../../../redux/product/product.actions';
export default (dispatch => ({
  onAddItemToCart: () => dispatch(placeItemInCart()),
  hidePopup: () => dispatch(hidePopup()),
  changeRelatedProductsPopupVisibility: () => dispatch(changeRelatedProductsPopupVisibility()),
  changeProductImageHoverStatus: isProductImageHovered => {
    dispatch(changeProductImageHoverStatus(isProductImageHovered));
  }
}));